// @flow

import React from 'react'
import styled from 'styled-components'
import type { Theme as ThemeType } from 'src/types'

type Props = {
  allowed: Array<string>,
  object: { [key: string]: string }
}
const StyledDetailTable = styled.table`
  border-collapse: separate;
  border-spacing: 30px 10px;
`

const StyledRow = styled.tr``

const Label = styled.td`
  font-family: 'CircularStd';
  font-family: CircularStd;
  font-size: 14px;
  color: ${(props: { theme: ThemeType }) => props.theme.secondaryText};
  text-transform: capitalize;
  vertical-align: text-top;
  text-align: right;
  padding: 5px 0;
`

const Value = styled.td`
  font-family: CircularStd;
  font-size: 14px;
  color: ${(props: { theme: ThemeType }) => props.theme.darkText};
  max-width: 200px;
`

export const DetailTable = ({ object, allowed }: Props) => {
  const objectSummary = allowed.map((key: string) => (
    <StyledRow key={key}>
      <Label>{key.replace(/([A-Z])/g, ' $1')}</Label>
      <Value>{object[key]}</Value>
    </StyledRow>
  ))

  return (
    <StyledDetailTable>
      <tbody>{objectSummary}</tbody>
    </StyledDetailTable>
  )
}



// WEBPACK FOOTER //
// ./src/components/DetailTable/index.js